import styled from 'styled-components';

import { donedealBreakpoints } from 'styled-system';
import { ImageCard, ImageCardProps } from './ImageCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${({ theme }) => theme.spacing.S8};
  row-gap: ${({ theme }) => theme.spacing.M16};

  ${donedealBreakpoints.media.large} {
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: ${({ theme }) => theme.spacing.M24};
    row-gap: ${({ theme }) => theme.spacing.M24};
  }
`;

interface ImageCardListProps {
  items: ImageCardProps[];
  className?: string;
}

function ImageCardList({ items, className }: ImageCardListProps) {
  return (
    <Grid className={className}>
      {items.map((item, index) => (
        <ImageCard key={index} {...item} />
      ))}
    </Grid>
  );
}

export { ImageCardList };
